module.exports = __webpack_public_path__ + "img/city.966e6816.jpg";